import { render, staticRenderFns } from "./RelatedAppointmentRequests.vue?vue&type=template&id=6ed3c277&"
import script from "./RelatedAppointmentRequests.vue?vue&type=script&lang=js&"
export * from "./RelatedAppointmentRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports